import "../../Components/Widgets/ContentTabs/ContentTabs.scss";

function initContentTabs(root) {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) {
        return;
    }

    const activate = (index, { focus = false } = {}) => {
        if (index < 0 || index >= tabs.length) {
            return;
        }

        tabs.forEach((tab, i) => {
            const selected = i === index;
            tab.classList.toggle("is-active", selected);
            tab.setAttribute("aria-selected", selected ? "true" : "false");
            tab.tabIndex = selected ? 0 : -1;
            if (panels[i]) {
                panels[i].hidden = !selected;
                panels[i].classList.toggle("is-active", selected);
            }
        });

        if (focus) {
            tabs[index].focus();
        }

        tabs[index].scrollIntoView({ inline: "nearest", block: "nearest" });
    };

    tabs.forEach((tab, i) => {
        tab.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            activate(i);
        });
        tab.addEventListener("keydown", (event) => {
            const keys = {
                ArrowRight: (i + 1) % tabs.length,
                ArrowLeft: (i - 1 + tabs.length) % tabs.length,
                Home: 0,
                End: tabs.length - 1
            };
            if (!(event.key in keys)) {
                return;
            }

            event.preventDefault();
            activate(keys[event.key], { focus: true });
        });
    });
}

function initAllContentTabs() {
    document.querySelectorAll("[data-content-tabs]").forEach((root) => {
        if (root.dataset.contentTabsReady === "true") {
            return;
        }

        root.dataset.contentTabsReady = "true";
        initContentTabs(root);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllContentTabs);
} else {
    initAllContentTabs();
}
